const header = () => {
    hideMenuOnScrollMobile();
    menuMobile();
    initMenu();
}
const hideMenuOnScrollMobile = () => {
    $(window).on('resize', function (event) {
        $(".header-menu").css({
            top: 0
        })
    })

    //ẩn menu khi scroll down, hiện khi scroll up. chỉ áp dụng với mobile
    let prevScrollValue = 0;
    $(window).on('scroll', function (event) {
        if ($(window).width() >= 1024) return;
        const scrollValue = $(window).scrollTop();

        if (scrollValue > prevScrollValue && scrollValue > 0) {
            //scroll down
            $(".header-menu").css({
                top: -80
            })
            $(".search-group-mobile").css({
                top: -80
            })
            $(".banner-fixed").css({
                top: 0
            })
        }
        else {
            //scroll up
            $(".header-menu").css({
                top: 0
            })
            $(".search-group-mobile").css({
                top: 81
            })
            $(".banner-fixed").css({
                top: 81
            })
        }
        prevScrollValue = scrollValue;
    });
}

const menuMobile = () => {
    $(".navbar-toggler").click(function () {
        $(".menu-mobile").fadeToggle("fadeIn");
        $(".search-group-mobile").fadeOut();
        $("#app").fadeToggle("fadeIn");
        $('html, body').animate({
            scrollTop: + $(".header-menu").position().top - 50
        }, 800);
    });

    $(".icon-search").click(function () {
        $(".menu-mobile").fadeOut();
        $(".search-group-mobile").fadeToggle();
        $("#app").fadeIn();
    });

    //click submenu
    $(".nav-item.has-sub-menu > .arrow").click(function () {
        const parent = $(this).parent(".nav-item");
        if (parent.hasClass("active")) {

            //phải đợi tất cả các element chạy xong mới thực hiện remove class
            let count = 0;
            const totalElement = parent.find(".sub-menu").length;

            parent.find(".sub-menu").slideUp(300, function () {
                count++;
                if (count >= totalElement) {
                    parent.removeClass("active");
                    parent.find(".nav-item").removeClass("active"); //xóa active của các sub-menu
                    changeBottomBar();
                }
            });

        } else {
            //tìm ở level 1 nếu có thì mở
            if (parent.find(".sub-menu:not(.sub-menu .sub-menu)").length > 0) {
                parent.addClass("active").find(".sub-menu:not(.sub-menu .sub-menu)").stop(true, true).slideDown(300, () => {
                    changeBottomBar();
                });
            }
            else {
                //nếu không thì mở level 2:
                parent.addClass("active").find(".sub-menu").stop(true, true).slideDown(300, () => {
                    changeBottomBar();
                });
            }
        }
    })
}

const changeBottomBar = () => {
    if ($(window).height() < ($(".bottom-bar").height() + $(".menu-mobile .navbar-nav").height() + 80)) {
        $(".bottom-bar").css({
            position: 'relative'
        })
    }
    else {
        $(".bottom-bar").css({
            position: 'fixed'
        })
    }
}

const initMenu = () => {
    $(".dropdown-item.active").parents(".submenu.dropdown-menu").parent().find(" > .dropdown-item").addClass("active")
    $(".dropdown-item.active").parents(".dropdown").addClass("active")
}

module.exports = header;
